// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"100ef1a4","453":"bde024a5","678":"5af8c42e"}[chunkId] + ".chunk.js";
};